import React, { ReactNode } from 'react';
import { FormModal, Text } from '@shootsta/common-react';
import type { RouterHistory } from '../../../types';
import FieldBlock from './FieldBlock';

import '../styles/_missing-fields-modal.scss';

type MissingField = {
  field: keyof typeof missingFieldsMap;
  stage: number;
  visible: boolean;
  showActionButton: boolean;
  callback: () => void;
};

type MissingFieldsModalProps = {
  title?: string;
  subtitle?: string;
  onClose: (visible: boolean) => void;
  visible: boolean;
  history: RouterHistory;
  missingFields: MissingField[];
  footerText?: string | ReactNode;
};

const missingFieldsMap = {
  name: {
    title: 'Title',
    subtitle: 'Please provide a name for your project template.'
  },
  allowedProjectTypes: {
    title: 'Project Template Details',
    subtitle: 'Please check that all mandatory fields have been filled in.'
  },
  customBriefMandatoryFields: {
    title: 'Custom Brief',
    subtitle: 'Please check that one mandatory question is added.'
  },
  customBriefs: {
    title: 'Custom Brief',
    subtitle: 'Please check that all field labels and descriptions have been filled in.'
  },
  additionalFields: {
    title: 'Additional Fields',
    subtitle: 'Please check that all mandatory fields have been filled in.'
  }
} as const;

const MissingFieldsModal: React.FC<MissingFieldsModalProps> = ({
  title = "You're Almost There",
  subtitle = "It looks like you haven't properly completed some of the steps.",
  visible,
  onClose,
  history,
  missingFields,
  footerText
}) => {
  return (
    <FormModal
      visible={visible}
      onClose={() => onClose(false)}
      hideFooter
      title={title}
    >
      <div className="missing-fields-modal">
        <Text block>{subtitle}</Text>
        <div className="missing-fields-modal__fields">
          {missingFields &&
            missingFields.map(
              ({
                visible: fieldVisible,
                field,
                stage,
                callback,
                showActionButton
              }: MissingField) => (
                <FieldBlock
                  key={field}
                  visible={fieldVisible}
                  onClose={onClose}
                  history={history}
                  stage={stage}
                  callback={callback}
                  showActionButton={showActionButton}
                  {...missingFieldsMap[field]}
                />
              )
            )}
        </div>
        {footerText && (
          <div className="missing-fields-modal__footer">
            <Text label noMargin="bottom">
              {footerText}
            </Text>
          </div>
        )}
      </div>
    </FormModal>
  );
};

export default MissingFieldsModal;
